import { yupResolver } from '@hookform/resolvers/yup';
import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { InferType } from 'yup';

import { emailSchema } from './email-schema';

export function useRegistrationEmailForm(email: string) {
  const resolver = useMemo(() => yupResolver(emailSchema), []);

  const form = useForm<InferType<typeof emailSchema>>({
    resolver,
    defaultValues: { email },
    mode: 'onChange',
  });

  return {
    form,
    formIsValid: useMemo(() => form.formState.isValid, [form.formState]),
  };
}
